<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="resetActive-book-modal"
    width="520px"
    center
    @closed="cancel"
  >
    <el-radio-group v-model="sltedBookId">
      <el-radio
        class="resetActive-radio"
        v-for="(item, index) in books"
        :key="index"
        :label="item.book_id"
        :disabled="item.activation_status != 1"
      >
        {{ item.book_title }}
      </el-radio>
    </el-radio-group>
    <el-row class="input">
      <el-col :span="6" class="label">激活码：</el-col>
      <el-col :span="14">
        <el-input v-model="activation_code"></el-input>
      </el-col>
    </el-row>

    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { resetActivationCodeDB } from "@/interface";
export default {
  data() {
    return {
      visible: false,
      books: [],
      activation_code: "",
      sltedBookId: null,
    };
  },
  methods: {
    openModal(obj) {
      const { series } = obj;
      this.books = series;
      this.visible = true;
    },
    cancel() {
      this.activation_code = "";
      this.sltedBookId = null;
      this.visible = false;
    },
    save() {
      if (!this.sltedBookId)
        return this.$message.error("请您选择要重新激活的电子书！");
      if (!this.activation_code) return this.$message.error("请填写激活码");
      const params = {
        book_id: this.sltedBookId,
        activation_code: this.activation_code,
      };

      resetActivationCodeDB(params).then((res) => {
        this.$message.success("激活成功");
        this.$emit("submitPopupData");
        this.sltedBookId = null;
        this.activation_code = "";
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss">
.resetActive-book-modal {
  .title {
    font-size: 16px;
    line-height: 1.5em;
    padding: 0 20px;
  }
  .input {
    margin-top: 20px;
    .label {
      color: #666;
      line-height: 38px;
      text-align: right;
    }
  }

  .resetActive-radio {
    margin: 10px 20px;
  }
}
</style>
